import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicAlphabetsStrings = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Alphabets, Strings, and Operations on Languages"
      videos={[
        "https://www.youtube.com/embed/ayoL_JkeVeY",
      ]}
      takeaways={[
        { text: "Remember all the definitions with examples." },
        { text: "Learn how to perform operations on grammar and understand what the resultant grammar will be after these operations." },
      ]}
      questions={[
        {text:"Define the terms: alphabet, string, and language with examples."},
        {text:"Explain the different operations that can be performed on languages."},
        {text:"What is the resultant grammar after performing a specific operation?"},
      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicAlphabetsStrings };